<script setup lang="ts">
import { onMounted } from "vue";
import { RouterView } from "vue-router";
import SiteFooter from "./components/SiteFooter.vue";
import SiteHeader from "./components/SiteHeader.vue";
import { useContent } from "./composables/useContent";

const { load } = useContent();

onMounted(() => {
  void load();
});
</script>

<template>
  <div class="app-shell">
    <SiteHeader />
    <main id="main-content">
      <RouterView />
    </main>
    <SiteFooter />
  </div>
</template>
